import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { useNavigator } from '@repo/toolkit/use-navigator'
import Box from '@repo/ui/box'
import { FilterTwoIcon } from '@repo/ui/icons'
import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

import { createOption } from '../../../api/options/create-option'
import UserNavBar from '../../../components/elements/nav-bar'
import JourneyPlaceOptionForm from '../../../components/pages/journey-places/option/journey-place-option-form'
import { Paths } from '../../../lib/constants/path'
import { twoButtonsConfig } from '../../../lib/utils/buttons-config/validation-buttons-config'
import { showAxiosError } from '../../../lib/utils/functions/misc.functions'

const JourneyPlaceOptionCreatePage = () => {
  const { navigate, back } = useNavigator()

  const { mutateAsync } = useMutation({
    mutationFn: createOption,
    onError: showAxiosError,
    onSuccess: () => toast.success('Option créée avec succès')
  })

  return (
    <div>
      <UserNavBar
        title={'Créer une option'}
        icon={(props) => <FilterTwoIcon {...props} fill={tailwindColors.secondary.DEFAULT} />}
      />
      <div className={'h-4'} />

      <Box>
        <JourneyPlaceOptionForm
          buttonsConfig={twoButtonsConfig({
            onConfirm: async (values) => {
              const res = await mutateAsync(values)
              navigate(Paths.JOURNEY_PLACE_OPTION_UPDATE_PAGE.replace(':id', res.id.toString()), {
                replace: true
              })
            },
            onCancel: () => back()
          })}
        />
      </Box>
    </div>
  )
}

export default JourneyPlaceOptionCreatePage
